import { useState, type FormEvent, type JSX } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../api.js';
import { Icon, Logo } from '../components/Icon.js';
import { BRAND } from '../branding.js';

export function ResetPassword(): JSX.Element {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const nav = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    setErr(null);
    if (password.length < 8) {
      setErr('Пароль должен быть не короче 8 символов');
      return;
    }
    if (password !== confirm) {
      setErr('Пароли не совпадают');
      return;
    }
    setBusy(true);
    try {
      await api.resetPassword(token, password);
      setDone(true);
      setTimeout(() => nav('/login', { replace: true }), 1500);
    } catch (e) {
      const status = (e as { status?: number }).status;
      setErr(status === 400 ? 'Ссылка недействительна или истекла' : 'Не удалось сменить пароль');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        background: 'var(--bg)',
        padding: 20,
      }}
    >
      <div style={{ width: 380, maxWidth: '100%' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            marginBottom: 24,
            justifyContent: 'center',
          }}
        >
          <Logo size={28} />
          <div style={{ fontWeight: 600, fontSize: 17, letterSpacing: -0.3 }}>{BRAND.name}</div>
        </div>
        <div className="card" style={{ padding: 28 }}>
          <h2 style={{ margin: '0 0 4px', fontSize: 19, fontWeight: 600, letterSpacing: -0.3 }}>
            Новый пароль
          </h2>
          <p style={{ margin: '0 0 20px', color: 'var(--fg-subtle)', fontSize: 13 }}>
            {done ? 'Пароль успешно обновлён, открываем вход…' : 'Введите новый пароль для входа.'}
          </p>
          {!token && !done && (
            <div style={{ fontSize: 13, color: 'var(--danger-fg)', marginBottom: 12 }}>
              Ссылка некорректна — токен отсутствует.
            </div>
          )}
          {!done && token && (
            <form onSubmit={onSubmit} className="stack">
              <div className="field">
                <label className="field-label">Новый пароль</label>
                <div className="field-prefix">
                  <span className="prefix-txt" style={{ paddingLeft: 10, paddingRight: 8 }}>
                    <Icon name="lock" size={13} />
                  </span>
                  <input
                    className="input"
                    type="password"
                    required
                    minLength={8}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="минимум 8 символов"
                    autoFocus
                  />
                </div>
              </div>
              <div className="field">
                <label className="field-label">Повторите пароль</label>
                <div className="field-prefix">
                  <span className="prefix-txt" style={{ paddingLeft: 10, paddingRight: 8 }}>
                    <Icon name="lock" size={13} />
                  </span>
                  <input
                    className="input"
                    type="password"
                    required
                    minLength={8}
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                  />
                </div>
              </div>
              {err && <div style={{ fontSize: 13, color: 'var(--danger-fg)' }}>{err}</div>}
              <button
                className="btn btn-primary"
                type="submit"
                disabled={busy}
                style={{ justifyContent: 'center', marginTop: 6 }}
              >
                {busy ? 'Сохраняем…' : 'Установить пароль'}
              </button>
            </form>
          )}
          <div style={{ textAlign: 'center', marginTop: 16 }}>
            <Link
              to="/login"
              style={{
                fontSize: 13,
                color: 'var(--fg-subtle)',
                textDecoration: 'none',
              }}
            >
              ← Вернуться ко входу
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
